import { Box, CardContent, Divider, Typography, useTheme } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { useI18n } from '../../shared-lib/i18n/i18n'
import CardContainer from './CardContainer'
import zIndexes from '../theme/zIndexes'
import { useLocation, useNavigate } from 'react-router'
import AppStoreButton from './AppStoreButton'
import GooglePlayButton from './GooglePlayButton'
import RootStore from '~/stores/RootStore'
import { observer } from 'mobx-react-lite'
import soloIcon from '~/assets/images/soloIcon.png'
import RectButton from './RectButton'

const deepLinkUrl = (env: string) => `https://app.${env === 'staging' ? 'demo.' : ''}booksolo.co/deep-link`

const DownloadAppPrompt = () => {
  const { s } = useI18n()
  const store = useContext(RootStore)
  const env = store?.config?.name
  const navigate = useNavigate()
  const isSmallScreen = store?.uiStore?.isSmallScreen
  const location = useLocation()
  const [appRoute, setAppRoute] = useState<string>(`${deepLinkUrl(env)}?screen=Home`)
  const theme = useTheme()

  useEffect(() => {
    const searchTerms = store?.searchManifestStore?.activeTerms
    const searchResult = isSmallScreen ? searchTerms?.find((term) =>
      term.address.desktopPath === location.pathname,
    ) : null

    setAppRoute(`${deepLinkUrl(env)}?screen=${searchResult?.address.appPath || 'Home'}`)
  }, [location.pathname, isSmallScreen])

  const isAuth = location.pathname.includes('auth')
  const isGoogleOnboarding = location.pathname.includes('setup/google-business-profile')
  const isSubscriptionsManage = location.pathname.includes('subscriptions') && location.pathname.includes('manage')

  if (!isSmallScreen || isAuth || isSubscriptionsManage || isGoogleOnboarding) return null

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        top: 0,
        zIndex: zIndexes.dialogs,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        p: 3,
        backdropFilter: 'blur(10px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CardContainer
        sx={{
          maxWidth: 400,
        }}
      >
        <CardContent sx={{ gap: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Box
            component='img'
            src={soloIcon}
            alt='solo-logo'
            width={theme.spacing(6)}
            sx={{
              borderRadius: theme.spacing(2),
              width: theme.spacing(12),
              height: theme.spacing(12),
              mt: 2,
              mb: 0,
            }}
          />

          <Typography variant='h6' sx={{ fontWeight: 'bold', textAlign: 'center' }}>{s('Use the Solo App to get the best mobile experience')}</Typography>
          <RectButton fullWidth onClick={() => window.open(appRoute)}>{s('Open in App')}</RectButton>
          <RectButton fullWidth variant='outlined' onClick={() => navigate('/subscriptions/manage')}>{s('Manage your Solo subscription')}</RectButton>

          <Divider sx={{ width: '100%', my: 2 }} />

          <Typography variant='body2'>{s('Don\'t have the App installed?')}</Typography>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <AppStoreButton height={8} />
            <GooglePlayButton height={8} />
          </Box>
        </CardContent>
      </CardContainer>
    </Box>
  )
}

export default observer(DownloadAppPrompt)